import './InteractiveBannerHero.css';
import React from 'react';
import { get, getPageThemeColors, getColorByTheme, canUseDOM } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import { stylesOldCarousel } from '../../utils/OldCarouselDotsStyles';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink';
export const InteractiveBannerHero = _ref => {
  let {
    fields,
    rendering,
    children,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const imageSrc = get(fields, 'data.item.gradient.jss.value.src');
  const imageAlt = get(fields, 'data.item.gradient.jss.value.alt');
  const timingJssValue = get(fields, 'data.item.timing.jss.value', 4000);
  const timingJssNumber = Number(timingJssValue);
  const timing = timingJssNumber < 4000 ? 4000 : timingJssNumber;
  const slides = get(fields, 'data.item.slides.targetItems') || [];
  const isOneItemSlider = slides.length === 1;
  const [autoplay, setAutoplay] = React.useState(true);
  const [iconplay, setIconPlay] = React.useState(true);
  const [isTablet, setIsTablet] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(false);
  const [activeBannerTitle, setActiveBannerTitle] = React.useState('');
  // const activeBannerTitle = React.useRef('')

  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const [isVdsite, setIsVdsite] = React.useState(true);
  const checkIsTablet = () => {
    const condition = canUseDOM && window.innerWidth <= 992;
    const conditionMobile = canUseDOM && window.innerWidth <= 768;
    setIsTablet(condition);
    setIsMobile(conditionMobile);
  };
  React.useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('resize', checkIsTablet);
      const interval = setInterval(checkIsTablet, 1000);
      return () => {
        window.removeEventListener('resize', checkIsTablet);
        clearInterval(interval);
      };
    }
  }, []);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      const header = document.querySelector('.dot-site-header');
      const interactiveBanner = document.querySelector('.m113-interactive-banner');
      if (header && interactiveBanner) {
        header.classList.add('transparency-mode');
      }
      return () => {
        if (header && interactiveBanner) {
          header.classList.remove('transparency-mode');
        }
      };
    }
  }, []);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    '--m113-interactive-bannerHero-background-color': BackgroundColorHex,
    '--m113-interactive-bannerHero-background-active-color': ActiveColorHex,
    '--m113-interactive-bannerHero-color': ColorHex
  } : {
    '--m113-interactive-bannerHero-background-color': selectedPrimaryColor,
    '--m113-interactive-bannerHero-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-interactive-bannerHero-color': getColorByTheme(selectedPrimaryColor)
  };
  Object.assign(variables, {
    '--m113-interactive-bannerHero-timing': `${timing / 1000}s`,
    '--m113-interactive-bannerHero-half-timing': `${timing / 1000 / 2}s`
  });
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('InteractiveBanner component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [InteractiveBanner component is empty: please provide data source]");
    }
    return null;
  }
  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-interactive-banner",
      rendering: rendering,
      bannerSlideTitle: activeBannerTitle
    });
  };
  const renderImage = (src, alt, image, initialHeight, innerWidth) => /*#__PURE__*/React.createElement(React.Fragment, null, canUseDOM && /*#__PURE__*/React.createElement(React.Fragment, null, src && /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: `${src}${src.includes('?') ? '&' : '?'}cw=${innerWidth}&ch=${initialHeight}`
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: `${src}${src.includes('?') ? '&' : '?'}cw=1280&ch=900`
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: `${src}${src.includes('?') ? '&' : '?'}cw=768&ch=900`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${src}${src.includes('?') ? '&' : '?'}cw=480&ch=900`,
    alt: alt ? alt : '',
    "aria-hidden": "true",
    "aria-label": alt
  }))), pageEditing && /*#__PURE__*/React.createElement(Image, {
    editable: true,
    field: image
  }));
  const renderItems = () => {
    if (slides.length) {
      return slides.map(item => {
        const imageSrc = get(item, 'image.jss.value.src');
        const imageHeight = get(item, 'image.jss.value.height');
        const imageWidth = get(item, 'image.jss.value.width');
        const imageAlt = get(item, 'image.jss.value.alt');
        const title = get(item, 'title.jss.value');
        const description = get(item, 'description.jss.value');
        const ctaLabel1 = get(item, 'ctaLabel1.jss.value');
        const ctaLink1Href = get(item, 'ctaLink1.jss.value.href');
        const ctaLink1Id = get(item, 'ctaLink1.jss.value.id');
        const ctaLink1Text = get(item, 'ctaLink1.jss.value.text');
        const ctaLink1Class = get(item, 'ctaLink1.jss.value.class');
        const ctaLabel2 = get(item, 'ctaLabel2.jss.value');
        const ctaLink2Href = get(item, 'ctaLink2.jss.value.href');
        const ctaLink2Text = get(item, 'ctaLink2.jss.value.text');
        const ctaLink2Id = get(item, 'ctaLink2.jss.value.id');
        const ctaLink2Class = get(item, 'ctaLink2.jss.value.class');
        return /*#__PURE__*/React.createElement("div", {
          className: "m113-interactive-banner__carousel-slide",
          key: item.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "slide-bg"
        }, imageSrc && renderImage(`${imageSrc}`, imageAlt, get(item, 'image'), imageHeight, imageWidth)), /*#__PURE__*/React.createElement("div", {
          className: "module-group"
        }, /*#__PURE__*/React.createElement("div", {
          className: "module"
        }, title && /*#__PURE__*/React.createElement("h3", {
          className: "slide-title h3"
        }, title), description && /*#__PURE__*/React.createElement("p", {
          className: "slide-desc"
        }, description), /*#__PURE__*/React.createElement("div", {
          className: "slide-btns"
        }, ctaLabel1 && /*#__PURE__*/React.createElement(RouterLink, {
          className: `${ctaLink1Class} slide-cta btn main`,
          href: ctaLink1Href,
          key: ctaLink1Id,
          onClick: () => {
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [title, ctaLabel1]);
          },
          dataCy: ctaLink1Text,
          linktype: "external",
          openInSameTab: true
        }, ctaLabel1, /*#__PURE__*/React.createElement("svg", {
          width: "17",
          className: "slide-cta-icon",
          height: "8",
          viewBox: "0 0 17 8",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z",
          fill: "white"
        }))), ctaLabel2 && /*#__PURE__*/React.createElement(RouterLink, {
          className: `${ctaLink2Class} slide-cta btn`,
          href: ctaLink2Href,
          key: ctaLink2Id,
          onClick: () => {
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [title, ctaLabel2]);
          },
          dataCy: ctaLink2Text,
          linktype: "external",
          openInSameTab: true
        }, ctaLabel2)))));
      });
    } else {
      return /*#__PURE__*/React.createElement("div", null);
    }
  };
  const render1Slide = () => {
    if (slides.length) {
      const item = slides[0];
      const imageSrc = get(item, 'image.jss.value.src');
      const imageHeight = get(item, 'image.jss.value.height');
      const imageWidth = get(item, 'image.jss.value.width');
      const imageAlt = get(item, 'image.jss.value.alt');
      const title = get(item, 'title.jss.value');
      const description = get(item, 'description.jss.value');
      const ctaLabel1 = get(item, 'ctaLabel1.jss.value');
      const ctaLink1Href = get(item, 'ctaLink1.jss.value.href');
      const ctaLink1Id = get(item, 'ctaLink1.jss.value.id');
      const ctaLink1Text = get(item, 'ctaLink1.jss.value.text');
      const ctaLink1Class = get(item, 'ctaLink1.jss.value.class');
      const ctaLabel2 = get(item, 'ctaLabel2.jss.value');
      const ctaLink2Href = get(item, 'ctaLink2.jss.value.href');
      const ctaLink2Text = get(item, 'ctaLink2.jss.value.text');
      const ctaLink2Id = get(item, 'ctaLink2.jss.value.id');
      const ctaLink2Class = get(item, 'ctaLink2.jss.value.class');
      return /*#__PURE__*/React.createElement("div", {
        className: "m113-interactive-banner-1-item m113-interactive-banner__carousel-slide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "slide-bg"
      }, imageSrc && renderImage(`${imageSrc}`, imageAlt, get(item, 'image'), imageHeight, imageWidth)), /*#__PURE__*/React.createElement("div", {
        className: "module-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "module"
      }, title && /*#__PURE__*/React.createElement("h3", {
        className: "slide-title h3"
      }, title), description && /*#__PURE__*/React.createElement("p", {
        className: "slide-desc"
      }, description), /*#__PURE__*/React.createElement("div", {
        className: "slide-btns"
      }, ctaLabel1 && /*#__PURE__*/React.createElement(RouterLink, {
        className: `${ctaLink1Class} slide-cta btn main`,
        href: ctaLink1Href,
        key: ctaLink1Id,
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [title, ctaLabel1]);
        },
        dataCy: ctaLink1Text,
        linktype: "external",
        openInSameTab: true
      }, ctaLabel1, /*#__PURE__*/React.createElement("svg", {
        width: "17",
        className: "slide-cta-icon",
        height: "8",
        viewBox: "0 0 17 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z",
        fill: "white"
      }))), ctaLabel2 && /*#__PURE__*/React.createElement(RouterLink, {
        className: `${ctaLink2Class} slide-cta btn`,
        href: ctaLink2Href,
        key: ctaLink2Id,
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [title, ctaLabel2]);
        },
        dataCy: ctaLink2Text,
        linktype: "external",
        openInSameTab: true
      }, ctaLabel2)))));
    } else {
      return /*#__PURE__*/React.createElement("div", null);
    }
  };
  const handleAutoPlay = () => {
    setAutoplay(a => !a);
    setIconPlay(a => !a);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [`${autoplay ? 'pause' : 'play'}`, activeBannerTitle]);
  };
  const handleSetActiveItem = state => {
    if (slides[state.currentSlide]) {
      const currentSlideTitle = slides[state.currentSlide].title.jss.value;
      setActiveBannerTitle(currentSlideTitle);
    }
  };
  const autoplayBtn = () => isOneItemSlider ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `m113-interactive-banner__autoplay ${!iconplay && 'paused'} ${isTablet ? 'tablet' : ''}`,
    onClick: () => handleAutoPlay()
  }, /*#__PURE__*/React.createElement("div", {
    id: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: `icon ${!iconplay && 'paused'}`
  }), iconplay ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "halfclip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "halfcircle",
    id: "clipped"
  })), /*#__PURE__*/React.createElement("div", {
    className: "halfcircle",
    id: "fixed"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null)));
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container m113-interactive-banner",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m113-interactive-banner__carousel"
  }, slides.length === 1 ? render1Slide() : /*#__PURE__*/React.createElement(CarouselProvider, {
    handleCustomAfterChange: data => handleSetActiveItem(data)
  }, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 1023,
            min: 0
          },
          items: 1
        }
      },
      autoPlay: autoplay,
      autoPlaySpeed: timing,
      infinite: true
    }), isTablet ? autoplayBtn() : null, isOneItemSlider ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("div", {
      className: `m113-interactive-banner__carousel__controls-sec ${rtl ? 'btn-group-rtl' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel-btn-left"
    }, renderPreviousButton(() => {
      if (autoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationOperatingOptionsAnalytics'], params), 'previous');
    }, false, true)), !isTablet ? autoplayBtn() : null, /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner___pagination-dots"
    }, renderDots(() => {
      if (autoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationBubblesAnalytics'], params));
    })), /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel-btn-right"
    }, renderNextButton(() => {
      if (autoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationOperatingOptionsAnalytics'], params), 'next');
    }, false, true))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "mouse mouse-1"
  })), /*#__PURE__*/React.createElement("div", {
    className: "placeholder-wrapper"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder())));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    removePadding: true,
    removePaddingInside: true,
    removePaddingTop: true,
    removePaddingBottom: true,
    className: ` ${commonStyles} ${stylesOldCarousel}  ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1qhvui9";
const ltrStyles = "l1mvnfzx";
const rtlStyles = "rb7cbn5";
export default InteractiveBannerHero;